import styled from 'styled-components/macro'
import { Z_INDEX } from '../../styles/z-index'

export const NotificationContainer = styled.div<{
  stickRight?: boolean
  isMobile?: boolean
  isNewNav?: boolean
}>`
  background: #fff;
  box-shadow:
    0px 1px 2px 0px rgba(30, 25, 25, 0.08),
    0px 2px 4px 0px rgba(30, 25, 25, 0.08),
    0px 4px 8px 0px rgba(30, 25, 25, 0.08),
    0px 8px 16px 0px rgba(30, 25, 25, 0.08),
    0px 8px 32px 0px rgba(30, 25, 25, 0.08);
  position: ${(props) => (props.isNewNav ? 'fixed' : 'absolute')};
  display: flex;
  width: 320px;
  flex-direction: column;
  top: ${(props) => (props.isNewNav ? 'var(--header-height)' : '0px')};
  border-radius: ${(props) => (props.isNewNav ? '12px' : '0px')};
  ${(props) =>
    props.isNewNav ? 'max-height: 900px;' : 'max-height: calc(100vh - 180px);'}
  ${(props) => (props.isNewNav ? 'overflow-y: auto; overflow-x: hidden;' : '')}
  justify-content: flex-start;
  align-items: flex-start;
  z-index: ${Z_INDEX.NOTIFICATION};
  ${(props) => (props.stickRight ? 'right: 20px;' : '')}

  ${(props) =>
    props.isNewNav
      ? `
    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.2);
      border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background-color: rgba(0, 0, 0, 0.3);
    }

    /* Firefox scrollbar styling */
    scrollbar-width: thin;
    scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
  `
      : ''}
`
export const NotificationHeader = styled.div<{ isMobile?: boolean }>`
  display: flex;
  padding: 12px 16px 8px 16px;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 1;

  color: ${(props) => (props.isMobile ? '#191d23' : '#0d5635')};
  font-family: Inter;
  font-size: ${(props) => (props.isMobile ? '24px' : '16px')};
  font-style: normal;
  font-weight: 500;
  line-height: 22px; /* 137.5% */
`

export const NotificationSubHeader = styled.div`
  width: 100%;
  display: flex;
  padding: 12px 16px 4px 16px;
  justify-content: space-between;
  align-items: center;

  color: #1a1918;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;

  & > a {
    font-size: 10px;
  }
`
